import React from 'react';
import { useOidc } from "@bnsf/oidc-token-lib-react/lib";
import { useLocation, useNavigate, useParams } from "react-router-dom";

export function withRouter(Component) {
    function ComponentWithRouterProp(props) {
        const { authUser: user } = useOidc();
        const location = useLocation();
        const navigate = useNavigate();
        const params = useParams();

        return <Component {...props} {...{ location, navigate, params, user }} />;
    }

    return ComponentWithRouterProp;
}